import { GetServerSidePropsContext } from 'next';

import { getRouteUrl } from '@utils/urls';
import { getLocaleFromContext } from '@utils/getLocaleFromContext';

import { PRODUCTS_CATEGORY } from '@common/routes.mjs';
import { LANGUAGE_DE } from '@common/constants/languages';

export default function RedirectToAllProductsCategory() {}

export const getServerSideProps = (context: GetServerSidePropsContext) => {
  const locale = getLocaleFromContext(context);

  return {
    redirect: {
      statusCode: 302,
      destination: getRouteUrl(locale, PRODUCTS_CATEGORY, {
        id: '1',
        slug: locale === LANGUAGE_DE ? 'bekleidung' : 'vetements',
      }),
    },
  };
};
